import { Tooltip } from '@abtasty/design-system';
import { WARNING_ID } from '@src/application/modules/shared/dataTestId';
import style from './Warning.module.scss';
import { useTheme } from 'styled-components';

export const Warning = ({ text, color }: { text: string; color: string }) => {
  return (
    <Tooltip content={text} placement="top" targetClassName={style.warningInfo}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        data-testid={WARNING_ID}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.696 3.30386C17.919 4.52684 18.5 6.57301 18.5 9.99991C18.5 13.4268 17.919 15.473 16.696 16.696C15.4731 17.9189 13.4269 18.4999 10 18.4999C6.5731 18.4999 4.52693 17.9189 3.30396 16.696C2.08098 15.473 1.5 13.4268 1.5 9.99991C1.5 6.57301 2.08098 4.52684 3.30396 3.30386C4.52693 2.08089 6.5731 1.49991 10 1.49991C13.4269 1.49991 15.4731 2.08089 16.696 3.30386ZM17.7567 2.2432C16.0889 0.575426 13.5101 -9.15527e-05 10 -9.15527e-05C6.4899 -9.15527e-05 3.91107 0.575426 2.2433 2.2432C0.575518 3.91098 0 6.48981 0 9.99991C0 13.51 0.575518 16.0888 2.2433 17.7566C3.91107 19.4244 6.4899 19.9999 10 19.9999C13.5101 19.9999 16.0889 19.4244 17.7567 17.7566C19.4245 16.0888 20 13.51 20 9.99991C20 6.48981 19.4245 3.91098 17.7567 2.2432Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 5.35481C9.58579 5.35481 9.25 5.6906 9.25 6.10481V9.99981C9.25 10.414 9.58579 10.7498 10 10.7498C10.4142 10.7498 10.75 10.414 10.75 9.99981V6.10481C10.75 5.6906 10.4142 5.35481 10 5.35481Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.7543 13.4998C10.7543 13.0856 10.4185 12.7498 10.0043 12.7498H9.9953C9.58109 12.7498 9.2453 13.0856 9.2453 13.4998C9.2453 13.914 9.58109 14.2498 9.9953 14.2498H10.0043C10.4185 14.2498 10.7543 13.914 10.7543 13.4998Z"
          fill={color}
        />
      </svg>
    </Tooltip>
  );
};

export const WarningWrapper = ({
  visitorVariationId,
  defaultVariationId,
  selectedVariationId,
}: {
  visitorVariationId?: string;
  defaultVariationId?: string;
  selectedVariationId?: string;
}) => {
  const theme = useTheme();
  if (selectedVariationId && selectedVariationId !== defaultVariationId) {
    return <Warning text="This variation has been changed" color={theme.dec.color.primary.default.fg.positive} />;
  }
  if (visitorVariationId !== defaultVariationId) {
    return <Warning text="This variation has been forced" color={theme.dec.color.primary.default.fg.moderate} />;
  }
  return null;
};
